exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".layer-name{text-transform:uppercase}.title-container{text-align:left;padding:12px 0}@keyframes blink{0%{opacity:.2}20%{opacity:1}to{opacity:.2}}.search-progress span{animation-name:blink;animation-duration:1.4s;animation-iteration-count:infinite;animation-fill-mode:both}.search-progress span:nth-child(2){animation-delay:.2s}.search-progress span:nth-child(3){animation-delay:.4s}.selected-count-caret{transform:rotate(90deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/views/combined/SearchResultHeaderView.css
// module id = 2000
// module chunks = 0